export * from './kommunikation.component';
export * from './kommunikation.component.module';